import React from 'react'

export default function Circle() {
  return (
    <svg
      className="absolute top-0 right-0"
      width="30"
      height="30"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.6"
        cx="18"
        cy="18"
        r="18"
        fill="#F38315"
        fill-opacity="0.4"
      />
    </svg>
  );
}
